<template>
  <form
    @submit.prevent="loginSubmit"
    @keydown="form.errors.clearall()"
    v-show="isShow"
    :class="{ formClass: isShow }"
    class="pb-2"
  >
    <div class="desc text-center">
      <!-- v-if="form.errors.has('phone')" -->
      <p class="text-danger h6" v-if="form.errors.any()">
        პაროლი ან მეილი არასწორია
      </p>
      <p v-else-if="unauth" class="text-danger">
        იმისათვის, რომ შეძლოთ შედეგების შენახვა გთხოვთ გაიაროთ ავტორიზაცია
      </p>
      <p v-else-if="message" class="text-danger" v-text="message"></p>
      <p v-else>გთხოვთ გაიროთ ავტორიზაცია!</p>
    </div>
    <div class="signUp">
      <span>
        <input
          class="form"
          placeholder="მობილური"
          v-model="form.phone"
          name="phone"
          autocomplete="off"
        />
        <span class="underline"></span>

        <p class="text-danger mt-m-20" v-if="form.errors.has('phone') && !form.phone">
          გთხოვთ შეიყვანოთ თქვენი მობილური
        </p>
        <p class="text-danger mt-m-20" v-if="form.errors.has('phone') && form.phone == ''">
          გთხოვთ შეიყვანოთ თქვენი მობილური
        </p>
      </span>
      <span>
        <input
          type="password"
          class="form"
          v-model="form.password"
          placeholder="პაროლი"
          name="password"
          autocomplete="off"
        />
        <span class="underline"></span>

        <p class="text-danger mt-m-20" v-if="form.errors.has('password') && !form.password">
          გთხოვთ შეიყვანოთ პაროლი
        </p>

        <p v-if="form.errors.has('password') && form.password == ''" class="text-danger mt-m-20">
          გთხოვთ შეიყვანოთ თქვენი მობილური
        </p>
      </span>

      <span>
        <div class="custom-control custom-checkbox">
          <input
            type="checkbox"
            class="custom-control-input"
            id="remember1"
            v-model="form.rememeber"
          />
          <label class="custom-control-label" for="remember1">დამახსოვრება</label>
        </div>
      </span>
    </div>
    <div class="text-center">
      <button @click="passwordReset = !passwordReset" type="button" class="btn btn-light btn-sm">
        პაროლის აღდგენა
      </button>

      <button
        :disabled="form.errors.any()"
        type="submit"
        :class="{ regsending: sending }"
        class="b-shadow-none btn btn-primary btn-link btn-sm"
      >
        გაგაზავნა
        <i class="fas fa-paper-plane"></i>
      </button>
    </div>

    <button @click="$emit('changeForm')" type="button" class="btn btn-light btn-block regBtn">
      რეგისტრაცია
    </button>
  </form>
</template>

<script>
import { Form } from '../../../form/form.js';
export default {
  props: ['isShow', 'unauth'],
  data() {
    return {
      form: new Form({ phone: '', password: '', rememeber: true }),
      password_msg: false,
      sending: false,
      message: false,
    };
  },
  methods: {
    loginSubmit() {
      this.sending = true;
      axios
        .post('/mylogin', this.form.data())
        .then((res) => {
          if (res.data.linkto) return (window.location.href = res.data.linkto);
          location.reload();
        })
        .catch((error) => {
          this.sending = false;
          this.form.errors.record(error.response.data.errors);
        });
    },
  },
  mounted() {
    window.bus.$on('authMsg', (data) => {
      this.message = data.msg;
    });
  },
};
</script>
